<template>
  <Teleport to="body">
    <!-- Modal -->
    <Transition name="modal">
      <div v-if="props.showModalLive" class="modal-mask-subs">
        <div class="modal-container">
          <div class="modal-body row justify-content-center">
            <div
              class="col-lg-12 col-12 d-flex align-items-center justify-content-center left-text"
            >
              <div class="row justify-content-center my-4">
                <div class="col-lg-12 col-12 text-center text1">
                  {{ translate.modalMsgLive1 }}
                  <br><br>
                  {{ translate.modalMsgLive2 }}
                </div>
                <div class="col-lg-12 col-12 text-center text2 mt-4">
                  {{ translate.modalMsgLive3 }}
                </div>
                <div class="d-md-flex mt-4 justify-content-around">
                  <div class="text-center text3 buttons-container" @click="redirect('language-assine')">
                    {{ translate.modalMsg4 }}
                  </div>
                  <div class="text-center text3 buttons-container" @click="checkCredits">
                    {{ translate.modalMsg5 }}
                  </div>
                  <div class="text-center text4 buttons-container"  @click="emit('closeModalLive', false)">
                    {{ translate.modalMsg7 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import translaters from "@/tradutors/live";
import api from "@/api";

const route = useRoute();
const router = useRouter();
const translate = computed(() =>
  route.params.language === "pt-br" ? translaters.portugues : translaters.ingles
);

const props = defineProps({
  showModalLive: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["closeModalLive"]);

function redirect(name: string) {
  router.push({ name, params: { language: route.params.language } });
}

function checkCredits() {
  api.get(`v1/mycredits/getCredits`).then(({ data }) => {
    if (data < 2) {
      redirectCredits('language-assine');
    } else {
      emit('closeModalLive', false)
      if (document.getElementById("btn-download-live") != null) {
        (document.getElementById("btn-download-live") as HTMLElement).click();
      }
    }
  });
}

function redirectCredits(name: string) {
  router.push({
    name: name,
    params: { language: route.params.language },
    query: { tab: 'credits' },
  });
}
</script>

<style scoped lang="css">

.modal-mask-subs {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.modal-container {
  position: fixed;
  z-index: 9998;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 900px;
  margin: auto;
  padding: 0px 50px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  border: 1px solid transparent;
  border-radius: 35px;
  background: 
    linear-gradient(white, white) padding-box,
    linear-gradient(to bottom, #FF6000, #FFC39E) border-box;
  background-clip: padding-box, border-box; 
  background-origin: padding-box, border-box; 

}

.modal-header {
  align-items: center;
  justify-content: end;
}

.modal-body {
  margin: 0;
}
.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.text1 {
  color: #ff6000;
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 30px;
  letter-spacing: 0;
  line-height: 17px;
}

.text2 {
  color: #000000;
  font-family: "Exo-2";
  font-weight: 400;
  font-size: 19px;
  letter-spacing: 0;
}

.text3 {
  background-color: #ff6000;
  color: #ffffff;
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 20px;
  padding: 3px 7px;
  border-radius: 7px;
  cursor: pointer;
  width: 220px;
  height: 30px;
}

.text4 {
  background-color: #4B4B4B;
  color: #ffffff;
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 20px;
  padding: 3px 7px;
  border-radius: 7px;
  cursor: pointer;
  width: 220px;
  height: 30px;
}


/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .modal-container {
    width: 95%;
    padding: 0px 20px;    
  }
  .text1 {
    line-height: 12px;
    font-size: 22px;
  }
  .text2 {
    line-height: 20px;
    font-size: 17px;
  }
  .text3 {
    line-height: 25px;
    margin-top: 20px;
    width: 300px;
  }
  .text4 {
    line-height: 25px;
    margin-top: 20px;
    width: 300px;
  }
  .buttons-container {
    left: 50%;
    transform: translate(-50%);
  }
}
</style>
